/**
 * @Author: Nemo
 * @Description: 表单校验工具 - 简单而强大
 * @Date: 2025-05-07
 * @FilePath: /rhcn-checkout-web/src/plugins/validator/index.js
 */

import { registerRule, getRule, createValidator } from './core';
import * as commonRules from './rules/common';

// 自动注册常用规则
Object.entries(commonRules).forEach(([name, rule]) => {
  registerRule(name, rule);
});

// 导出主要API
export {
  registerRule, // 注册自定义规则
  getRule, // 获取已注册规则
  createValidator, // 创建校验器实例
};
